exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".required[data-v-1a7ac003] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-weight: bold;\n}\n.text-danger.field-validation-error[data-v-1a7ac003] {\n  padding-bottom: 5px;\n}\n.validate.invalid[data-v-1a7ac003] {\n  border: 2px solid crimson !important;\n  border-radius: 5px;\n}\n", ""]);

